import Reveal from "./Reveal";
import Streams from "./Streams";
import Chapter from "./Chapter";
import Marquee from "./Marquee";
import Convergence from "./Convergence";
import Philosophy from "./Philosophy";
import Portfolio from "./Portfolio";
import Finale from "./Finale";

const CHAPTERS = [
  {
    id: "chapter-01",
    index: "01",
    title: "Real Estate",
    subtitle: "Values with substance.",
    body: [
      "Sypama invests in selected properties and real estate developments with a long-term perspective.",
      "Not the short-term moment, but location, quality, development potential and sustainable value preservation.",
    ],
    process: ["ACQUIRE", "DEVELOP", "HOLD", "CREATE VALUE"],
    quote: "Real assets. Long-term thinking.",
  },
  {
    id: "chapter-02",
    index: "02",
    title: "Equities",
    subtitle: "Participation in progress.",
    body: [
      "Through listed companies, Sypama invests in business models, markets and developments with long-term potential.",
      "The focus is not on short-term movements. Companies. Quality. Growth. Future viability.",
    ],
    pillars: ["PUBLIC MARKETS", "GLOBAL OPPORTUNITIES", "LONG-TERM CAPITAL"],
    quote: "We don\u2019t invest in prices. We invest in businesses.",
    flip: true,
  },
  {
    id: "chapter-03",
    index: "03",
    title: "Private Equity",
    subtitle: "Entrepreneurial capital.",
    body: [
      "Sypama takes direct stakes in selected companies and entrepreneurial projects. For us, capital means more than investment.",
      "Capital. Network. Strategy. Development. We seek participations where an investment becomes a long-term partnership.",
    ],
    process: ["PARTICIPATE", "SUPPORT", "GROW"],
    quote: "We invest in companies. And in the people building them.",
  },
];

export default function Story({ onContact, onExplore, scrollTo, pedestalRef }) {
  return (
    <>
      <section
        data-testid="opening"
        className="flex min-h-[92vh] flex-col justify-center px-6 pt-28 sm:px-[8vw]"
      >
        <p className="f-mono mb-8 text-[11px] tracking-[0.35em] text-[#B8860B]">
          OUR VISION
        </p>
        <h2 className="f-display max-w-5xl text-4xl font-light leading-[1.05] tracking-tight text-slate-900 sm:text-6xl lg:text-7xl">
          <Reveal>Capital is the beginning.</Reveal>
          <Reveal delay={0.18}>
            Value is created <span className="italic text-[#B8860B]">through decisions.</span>
          </Reveal>
        </h2>
        <div className="mt-20 flex items-center gap-4">
          <div className="h-16 w-px overflow-hidden bg-slate-200">
            <div className="scroll-hint-line h-full w-full bg-[#D4AF37]" />
          </div>
          <p className="f-mono text-[10px] tracking-[0.4em] text-slate-400">SCROLL</p>
        </div>
      </section>

      <Streams scrollTo={scrollTo} />

      {CHAPTERS.map((c) => (
        <Chapter key={c.id} {...c} />
      ))}

      <Marquee />
      <Convergence />
      <Philosophy />
      <Portfolio />
      <Finale onContact={onContact} onExplore={onExplore} pedestalRef={pedestalRef} />
    </>
  );
}
